<template>
  <div class="post-login-layout">
    <SideMenu
      :logo="menuLogo"
      @reload="handleMenu(true)"
      @action="menuAction"
      @close="toggleMenu()"
    />
    <NavigationBar
      @search-submit="handleSearch"
      @menu-event="toggleMenu()"
    />
    <AgentsBar v-if="!$route.name?.toLowerCase().includes('statistic') && agent" />
    <ContentLayout />
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useRootStore } from '@/stores/root';
import { useNavigationStore } from '@/stores/navigation';
import { useAppBreakpoints } from '@/composables/useBreakpoints';
import authentication from '@/services/authentication';
import NavigationBar from '@/components/navigation/NavigationBar.vue';
import SideMenu from '@/components/navigation/SideMenu.vue';
import ContentLayout from '@/components/layout/ContentLayout.vue';
import AgentsBar from '@/components/bars/AgentsBar.vue';


export default {
  name: 'PostLoginLayout',
  components: {
    NavigationBar,
    SideMenu,
    ContentLayout,
    AgentsBar,
  },
  setup() {
    const { isDesktop } = useAppBreakpoints();
    return { isDesktop };
  },
  computed: {

    ...mapState(useRootStore, [
      'user',
      'menuOpened',
      'agent',
    ]),
    menuLogo() {
      // optional chaining: user può essere null (logout / sessione scaduta) mentre il
      // layout è ancora montato → evita null.profile nel render.
      const p = this.user?.profile;
      if (p?.crmflg === 'S' && p?.biflg === 'N') return '/img/logo/logo-crm.png';
      else if (p?.crmflg === 'N' && p?.biflg === 'S') return '/img/logo/logo-bi.png';
      else if (p?.crmflg === 'S' && p?.biflg === 'S') return '/img/logo/logo-crm-bi.png';
      return '/img/naviga-white_crm.png';
    },
  },
  async created() {
    this.setMenuOpened(this.isDesktop);
  },
  methods: {
    ...mapActions(useRootStore, [
      'setMenuOpened',
      'setUser',
      'setSearchText',
      'setSideMenu',
      'setLastCustomer',
      'setLoggingOut',
    ]),
    ...mapActions(useNavigationStore, [
      'fetchSideMenu',
    ]),
    handleSearch(query) {
      this.setSearchText(query);
    },
    async menuAction(action) {
      if (action === 'logout') {
        // Navigare a /login PRIMA di azzerare lo stato, col flag `loggingOut` per non far
        // rimbalzare l'utente (ancora valorizzato) nella sua app. Così la dashboard si
        // SMONTA prima del clear → niente remount card / chiamate API in teardown (401)
        // né crash su user null. Stato azzerato dopo la navigazione.
        this.setLoggingOut(true);
        authentication.logout();
        await this.$router.push('/login');
        this.setUser(null);
        this.setLastCustomer(null);
        this.setMenuOpened(false);
        this.setSideMenu([]);
        this.setLoggingOut(false);
      }
    },
    toggleMenu() {
      this.setMenuOpened(!this.menuOpened);
    },
    async handleMenu(forceRefresh) {
      this.fetchSideMenu({ forceRefresh });
    },
  },
};

</script>

<style lang="scss">

.post-login-layout {
  flex: 1 1 auto;
  backface-visibility: hidden;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 100%;
  position: relative;
}


</style>
